var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal", duration: 400 } }, [
    _c(
      "div",
      {
        staticClass: "modal clearfix",
        on: {
          click: function ($event) {
            _vm.close("bg")
          },
        },
      },
      [
        _c("div", { staticClass: "modal-bg" }),
        _vm._v(" "),
        _c("div", { staticClass: "modal-scroll" }, [
          _c(
            "div",
            {
              staticClass: "modal-dialog",
              class: _vm.className,
              on: {
                click: function ($event) {
                  _vm.modalDialogClicked($event)
                },
              },
            },
            [
              _c("div", { staticClass: "modal-content" }, [
                !_vm.hideClose
                  ? _c("div", { staticClass: "modal-close-btn" }, [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.close($event)
                            },
                          },
                        },
                        [_c("i", { staticClass: "ion-ios-close-empty" })]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _vm._t("body", [
                      _vm._v("\n              default body\n            "),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.hideFooter
                  ? _c(
                      "div",
                      { staticClass: "modal-footer" },
                      [_vm._t("footer")],
                      2
                    )
                  : _vm._e(),
              ]),
            ]
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/Modal/template.html?vue&type=template&id=99ac8e20&
// module id = 1069
// module chunks = 0